import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import './index.less';
import { isWXMiniAppBrowser } from '@/utils';
import { addClass, stringToDom } from '@/utils/dom';

var PayModel = function () {
  function PayModel() {
    this.content = null;
    this.elementType = '';
  }

  PayModel.prototype.appScript = function () {
    var script = document.createElement('script');
    script.setAttribute('async', 'async');
    script.setAttribute('src', 'https://design.tinman.cn/library/qrcode/1.5.1/qrcode.20228307195.js');
    document.head.appendChild(script);
  };

  PayModel.prototype.getQrCodeStr = function (payUrl) {
    return __awaiter(this, void 0, void 0, function () {
      var qrCodeUrl;
      return __generator(this, function (_a) {
        qrCodeUrl = payUrl;
        return [2
        /*return*/
        , new Promise(function (resolve, reject) {
          var _a;

          (_a = window === null || window === void 0 ? void 0 : window.QRCode) === null || _a === void 0 ? void 0 : _a.toDataURL(qrCodeUrl, {
            margin: 0,
            errorCorrectionLevel: 'L'
          }, function (err, url) {
            if (err) {
              reject(err);
            } else {
              resolve(url);
            }
          });
        })];
      });
    });
  };

  PayModel.prototype.createQrCode = function (ElContent, payUrl) {
    if (payUrl === void 0) {
      payUrl = '';
    }

    return __awaiter(this, void 0, void 0, function () {
      var url;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!ElContent || !payUrl) return [2
            /*return*/
            ];
            return [4
            /*yield*/
            , this.getQrCodeStr(payUrl)];

          case 1:
            url = _a.sent();
            ElContent.setAttribute('src', url);
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // 支付状态


  PayModel.prototype.show = function (_a) {
    var _this = this;

    var onClose = _a.onClose,
        onCancel = _a.onCancel,
        price = _a.price,
        payUrl = _a.payUrl;
    this.factory(stringToDom(
    /* html */
    "\n          <div class=\"ali-scan-pay-container\">\n          <i class=\"ui-icon ui-icon-close\"></i>\n              <div class=\"ali-scan-pay-title\">\n                <i class=\"ui-icon ui-icon-ali__pay \"></i>\n                <h4>\u652F\u4ED8\u5B9D\u626B\u7801\u652F\u4ED8</h4>\n              </div>\n              <P class=\"ali-scan-pay-price\">\xA5".concat(price || 0, "</P>\n              <img class=\"qrcode\" alt='' />\n              <div class=\"ali-scan-cancel-btn\">\u53D6\u6D88</div>\n              ").concat(isWXMiniAppBrowser() ? '' : '<div class="ali-sacnpay-tip">检测到您未安装支付宝，请安装支付宝后扫码支付</div>', "\n             \n          </div>\n        ")), 'pay', function () {
      var _a, _b, _c;

      var $close = (_a = _this.content) === null || _a === void 0 ? void 0 : _a.querySelector('.ui-icon-close');
      var $cancel = (_b = _this.content) === null || _b === void 0 ? void 0 : _b.querySelector('.ali-scan-cancel-btn');
      var $qrcode = (_c = _this.content) === null || _c === void 0 ? void 0 : _c.querySelector('.qrcode');

      _this.createQrCode($qrcode, payUrl); // 关闭


      $close.onclick = function () {
        if (onClose) {
          onClose();
        }

        _this.hide();
      };

      $cancel.onclick = function () {
        if (onCancel) {
          onCancel();
        }

        _this.hide();
      };
    });
  };

  PayModel.prototype.hide = function () {
    if (this.content) {
      document.body.removeChild(this.content);
      this.content = null;
    }
  };

  PayModel.prototype.factory = function (innerCont, type, cb) {
    this.hide();
    var content = document.createElement('div');
    addClass(content, 'ali-scan-pay-model');
    content.appendChild(innerCont);
    document.body.appendChild(content);
    this.content = content;
    this.elementType = type;

    if (typeof cb === 'function') {
      cb();
    }
  };

  return PayModel;
}();

export default new PayModel();